/*
 * Copyright (c) 2026. Bolmate B.V.
 */

import React, {MouseEventHandler} from 'react';
import {ErrorType, Loader, WithBackground} from "@dvrd/dvr-controls";
import classNames from 'classnames';
import CodeInputController from "../../controls/codeInput/codeInputController";

interface Props {
    onClose: MouseEventHandler;
    onSubmit: (code: string) => void;
    active: boolean;
    loading: boolean;
    error: ErrorType;
    email: string;
}

export default function IpVerification(props: Props) {
    const {onClose, onSubmit, active, loading, error, email} = props;

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='login-validation'>
                <div className='header-container'>
                    <label className='header-title'>Verificatiecode in jouw e-mail</label>
                </div>
                <div className='body-container'>
                    <Loader active={loading}/>
                    <label>Voer de 4-cijferige code in, deze is verzonden naar {email}</label>
                    <CodeInputController onSubmit={onSubmit} numbersOnly autoSubmit/>
                    <label className={classNames('error-label', !!error && 'visible')}>{error}</label>
                    <div className='code-info'>
                        <label className='code-info-label'>Geen code ontvangen?</label>
                        <p className='info-message'>
                            1) Check je spam<br/>
                            2) Refresh je inbox<br/>
                            3) Check het e-mailadres<br/><br/>
                            Na 5 minuten nog niks ontvangen?<br/>
                            Neem dan contact op met onze klantenservice.
                            <br/><br/>
                            Tip: Schakel 2FA in, dan geen e-mail meer
                        </p>
                    </div>
                </div>
            </div>
        </WithBackground>
    )
}